import axios from 'axios'

export class RestClient {
  /**
   * RestClient constructor
   *
   * @constructor
   */
  constructor () {
    this.params = {}
  }

  /**
   * Add params to the request
   *
   * @param {string} key - The key of the param
   * @param {*} value - The value of the param
   *
   * @returns {RestClient}
   */
  addParam (key, value) {
    this.params[key] = value
    return this
  }

  /**
   * Include other resources into the request
   *
   * @param {(...string|string[])} resources - Resources to be included
   *
   * @returns {RestClient}
   */
  include (...resources) {
    this.params.include = this.parseParameterArray(resources).join(',')

    return this
  }

  /**
   * Add filters to the request
   *
   * @param {(...array|array[])} rules - Filter rules
   *
   * @returns {RestClient}
   */
  filter (...rules) {
    this.params.filter = this.parseParameterArray(rules, true).map(rule => {
      if (Array.isArray(rule[2])) rule[2] = '{' + rule[2].join(';') + '}'

      return rule.join(':')
    }).join(',')

    return this
  }

  /**
   * Sort the query results
   *
   * @param {(...string|string[])} rules - The rules used for sorting
   *
   * @returns {RestClient}
   */
  sort (...rules) {
    this.params.sort = this.parseParameterArray(rules).join(':')

    return this
  }

  /**
   * Return the given page
   *
   * @param {number} page - The page to return
   *
   * @returns {RestClient}
   */
  page (page) {
    this.params.page = page

    return this
  }

  /**
   * Limit the number of results
   *
   * @param {number} count  - Max number of results
   *
   * @returns {RestClient}
   */
  limit (count) {
    this.params.limit = count

    return this
  }

  /**
   * Make an http request using axios
   *
   * @param {string} method       - HTTP method
   * @param {string} url          - API endpoint
   * @param {Object} [data={}]    - Request body
   * @param {Object} [headers={}] - Extra headers
   * @param {Object} [options={}] - Raw axios options
   *
   * @returns {AxiosPromise}
   */
  call (method, url, data = {}, headers = {}, options = {}) {
    return axios.request(Object.assign({
      method,
      url,
      params: this.params,
      data,
      headers
    }, options))
  }

  /**
   * Check if one parameter array or multiple parameters were passed
   *
   * @param {Array}    params          - The parameters to parse and extract
   * @param {boolean}  paramsAreArrays - Parameters are arrays. Checks if first argument is 2D array
   *
   * @returns {Array}
   */
  parseParameterArray (params, paramsAreArrays = false) {
    if (paramsAreArrays === true) {
      return (Array.isArray(params[0]) && Array.isArray(params[0][0])) ? params[0] : params
    }

    return Array.isArray(params[0]) ? params[0] : params
  }

  /**
   * Parse the parameter array and join the elements using a comma
   *
   * @param {Array} params
   *
   * @returns {string}
   */
  parseAndJoin (params) {
    return this.parseParameterArray(params).join(',')
  }
}
